export default {"src":"/_next/static/media/user.1a01ef0e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};